import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here
import Config from "../../../../Config.jsx";

import Localization from "../../../../Localization.jsx"

import {
  Grid,
  TextField,
  FormControl,
  Select,
  FormControlLabel,
  MenuItem,
  Checkbox,
} from '@material-ui/core';

const playbackKind = 2; // MC
const maxAttempt = 4;

class MCForm extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    var defaultPayloadData = {
      ans_arr: [
        {"text": "", "img_path": "", "is_correct": 0},
        {"text": "", "img_path": "", "is_correct": 0},
        {"text": "", "img_path": "", "is_correct": 0},
        {"text": "", "img_path": "", "is_correct": 0},
      ]
    };

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      content: "",
      attemptArray: [],
      triggerMode: -1,
      payloadData: defaultPayloadData,
    };
    autoBind(this);

    if (this.props.playbackData) {
      this.state.content = this.props.playbackData['content'];
      this.state.triggerMode = parseInt(this.props.playbackData['trigger_mode']);
      this.state.payloadData = (this.props.playbackData['payload'] != ""? JSON.parse(this.props.playbackData['payload']) : defaultPayloadData);
    }

    for (let i = 0; i < maxAttempt; i++) {
      this.state.attemptArray.push(null);
    }
  }

  numberOfAttemptAllowedChanged(e) {
    this.setState({ triggerMode: e.target.value });
    this.state.triggerMode = e.target.value;
  }

  onContentChanged(e) {
    this.setState({ content: e.target.value });
    this.state.content = e.target.value;
  }

  textChanged = index => event => {
    let payload = this.state.payloadData;
    payload['ans_arr'][index]['text'] = event.target.value;
    this.setState({ payloadData: payload });
    this.state.payloadData = payload;
  }

  checkboxChanged = index => event => {
    let payload = this.state.payloadData;
    payload['ans_arr'][index]['is_correct'] = (event.target.checked? 1 : 0);
    this.setState({ payloadData: payload });
    this.state.payloadData = payload;
  }

  validateInput() {
    let result = true;
    let errorMessage = "";
    let answerArray = this.state.payloadData['ans_arr'];
    if (answerArray[0]['text'].trim() == "") {
      errorMessage = "Choice A cannot be blank";
      result = false;
    }
    else if (answerArray[1]['text'].trim() == "") {
      errorMessage = "Choice B cannot be blank";
      result = false;
    }
    else if (answerArray[2]['text'].trim() == "") {
      errorMessage = "Choice C cannot be blank";
      result = false;
    }
    else if (answerArray[3]['text'].trim() == "") {
      errorMessage = "Choice D cannot be blank";
      result = false;
    }
    else if (this.state.content.trim() == "") {
      errorMessage = "Question cannot be blank";
      result = false;
    }

    let hasCorrectAnswer = false;
    for (let i = 0; i < answerArray.length; i++) {
      if (answerArray[i]['is_correct'] > 0) {
        hasCorrectAnswer = true;
      }
    }
    if (!hasCorrectAnswer) {
      errorMessage = "There should be at least one correct answer";
      result = false;
    }

    if (errorMessage != "") {
      this.props.root.addNotification(errorMessage);
    }
    
    return result;
  }

  updatePlayback(new_id) {
    let requestObj = {
      playback_id: new_id,
      kind: playbackKind,
      trigger_time: (this.props.playbackData? this.props.playbackData['trigger_time'] : this.props.root.refs.stageViewerPage.refs.stageDetailView.refs.stageMediaView.state.playbackTime),
      trigger_mode: this.state.triggerMode,
      should_pause_video: Config.GET_PLAYBACK_CONFIG(playbackKind)['shouldPauseVideo'],
      pos_x: 0,
      pos_y: 0,
      countdown_limit: 0,
      content: this.state.content.trim(),
      payload: JSON.stringify(this.state.payloadData),
    };
    this.props.root.refs.API.request("update_playback", requestObj, this.props.parent.updatePlaybackOK, this.props.parent.updatePlaybackFailed);
  }

  render() {
    return (
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={2}>
            {Localization.strings.QUESTION}
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              value={this.state.content}
              onChange={this.onContentChanged}
            />
          </Grid>
          <Grid item sm={4}/>
          <Grid item xs={12} sm={2}>
            {Localization.strings.NUMBER_OF_ATTEMPT_S}
          </Grid>
          <Grid item xs={12} sm={10}>
            <FormControl>
              <Select
                value={this.state.triggerMode}
                onChange={this.numberOfAttemptAllowedChanged}
              >
                <MenuItem value={-1}>{Localization.strings.DEFAULT+" (4)"}</MenuItem>
                {this.state.attemptArray.map((row, i) => {
                  return (
                    <MenuItem key={i} value={i}>{i+1}</MenuItem>
                  )
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} style={{padding:"14px"}}>
            <TextField
              label={Localization.strings.CHOICE+" A"}
              fullWidth
              value={this.state.payloadData['ans_arr'][0]['text']}
              onChange={this.textChanged(0)}
              InputProps={{
                endAdornment:
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.payloadData['ans_arr'][0]['is_correct'] > 0}
                        onChange={this.checkboxChanged(0)}
                      />
                    }
                    label={Localization.strings.CORRECT}
                  />
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{padding:"14px"}}>
            <TextField
              label={Localization.strings.CHOICE+" B"}
              fullWidth
              value={this.state.payloadData['ans_arr'][1]['text']}
              onChange={this.textChanged(1)}
              InputProps={{
                endAdornment:
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.payloadData['ans_arr'][1]['is_correct'] > 0}
                        onChange={this.checkboxChanged(1)}
                      />
                    }
                    label={Localization.strings.CORRECT}
                  />
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{padding:"14px"}}>
            <TextField
              label={Localization.strings.CHOICE+" C"}
              fullWidth
              value={this.state.payloadData['ans_arr'][2]['text']}
              onChange={this.textChanged(2)}
              InputProps={{
                endAdornment:
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.payloadData['ans_arr'][2]['is_correct'] > 0}
                        onChange={this.checkboxChanged(2)}
                      />
                    }
                    label={Localization.strings.CORRECT}
                  />
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{padding:"14px"}}>
            <TextField
              label={Localization.strings.CHOICE+" D"}
              fullWidth
              value={this.state.payloadData['ans_arr'][3]['text']}
              onChange={this.textChanged(3)}
              InputProps={{
                endAdornment:
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.payloadData['ans_arr'][3]['is_correct'] > 0}
                        onChange={this.checkboxChanged(3)}
                      />
                    }
                    label={Localization.strings.CORRECT}
                  />
              }}
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default MCForm;
